$(document).on('change', '#frm_alerteclient_add [name="alerte"]', function() {
	var $this = $(this);
	if( $this.prop('checked') )
		$('#frm_alerteclient_add_zone_alerte_date').removeClass('d-none');
	else
		$('#frm_alerteclient_add_zone_alerte_date').addClass('d-none');
});

// ajout alerte
$(document).on('submit', '#frm_alerteclient_add', function(e) {
	e.preventDefault();
	var $this = $(this);
	var data = {};
	data.texte = $('[name="texte"]').val();
	data.alerte = $('[name="alerte"]').prop('checked') ? 1 : 0;
	data.alerte_date = $('[name="alerte_date"]').val();
	$.ajax({
		type: "POST",
		url: $this.attr('action'),
		data: { action: 'alerteclientadd', data: data }
	}).done(function(data) {
		$.fancybox.getInstance().setContent($.fancybox.getInstance().current, data);
	});
});

// suppression alerte
$(document).on('click', '#alerteclient [name="delete"]', function(e) {
	e.preventDefault();
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		dataType: 'json',
		data: { action: 'alerteclientdelete', id: $this.data('actiondelete') }
	}).done(function(data) {
		if( data.success )
			$this.parents('tr').get(0).remove();
	});
});

// modification alerte
$(document).on('click', '#alerteclient [name="edit"]', function(e) {
	e.preventDefault();
	var $this = $(this);
	var data = $this.data('actionedit');
	var formcontent = $('#frm_alerteclient_modify').html();
	var random_str = Math.floor((Math.random() * 100000000) + 1).toString();
	formcontent = formcontent.replace(/{{random}}/g, random_str);
	formcontent = formcontent.replace(/{{value.id}}/g, data.id);
	formcontent = formcontent.replace(/{{value.texte}}/g, data.texte);
	formcontent = formcontent.replace(/{{value.alerte_date}}/g, data.alerte ? data.alerte : '');
	formcontent = formcontent.replace(/{{checked}}/g, data.alerte ? 'checked' : '');
	formcontent = formcontent.replace(/{{hide_date}}/g, data.alerte ? '' : 'd-none');
	$($this.parents('tr').get(0)).after('<tr><td colspan="4">' + formcontent + '</td></tr>');
	$('[data-toggle="datepicker"]', $($this.parents('tr').get(0)).next('tr')).datepicker({
		language: 'fr-FR',
		autoHide: true,
		zIndex: 99999
	});
	$($this.parents('tr').get(0)).addClass('d-none');
});

$(document).on('click', '.frm_alerteclient_modify [name="annuler"]', function(e) {
	e.preventDefault();
	var $this = $(this);
	$($this.parents('tr').get(0)).prev('tr').removeClass('d-none');
	$this.parents('tr').get(0).remove();
});

$(document).on('change', '.frm_alerteclient_modify [name="alerte"]', function() {
	var $this = $(this);
	if( $this.prop('checked') )
		$($this.data('target')).removeClass('d-none');
	else
		$($this.data('target')).addClass('d-none');
});

$(document).on('submit', '.frm_alerteclient_modify', function(e) {
	e.preventDefault();
	var $this = $(this);
	var data = {};
	data.id = $('[name="id"]', $this).val();
	data.texte = $('[name="texte"]', $this).val();
	data.alerte = $('[name="alerte"]', $this).prop('checked') ? 1 : 0;
	data.alerte_date = $('[name="alerte_date"]', $this).val();
	data.alertes_dashboard = $('#alerteclient').hasClass('alertes_dashboard') ? 1 : 0;
	$.ajax({
		type: "POST",
		url: $this.attr('action'),
		data: { action: 'alerteclientmodify', data: data }
	}).done(function(data) {
		if( $('#alerteclient').hasClass('alertes_dashboard') )
			$('#frm_dashboard_alertes').html(data);
		else
			$.fancybox.getInstance().setContent($.fancybox.getInstance().current, data);
	});
});